<div
  *cftI18n="let t"
  class="filter__container"
  [class.filter__container__active]="filterControl.valueChanges | async"
  (click)="onClick()"
>
  @if (searchDisabled()) {
    <span class="filter__select">
      @if (icon()) {
        <fa-icon class="filter__icon" [icon]="icon()!"></fa-icon>
      }
      <p class="filter__select__value" data-testid="selected-value">
        {{ filterControl.value || placeholder() || t('filter.title') }}
      </p>
    </span>
  } @else {
    <div
      class="filter__placeholder"
      [ngClass]="{
        'filter__placeholder--hidden': isFocused,
      }"
    >
      @if (icon()) {
        <fa-icon class="filter__icon" [icon]="icon()!"></fa-icon>
      }
      <p class="filter__placeholder__value">
        {{ filterControl.value || placeholder() || t('filter.title') }}
      </p>
    </div>
    <input
      type="text"
      [class.focus]="isFocused"
      [formControl]="filterControl"
      (focus)="onFocus()"
      (blur)="onBlur()"
      [placeholder]="t('filter.placeholder')"
      #filterInput
    />
  }
  <fa-icon
    (click)="handleClearButton($event)"
    class="z-10 mr-0 ml-auto sm:pl-8"
    [icon]="isItemSelected ? clearSelectiondIcon : menuClose"
  ></fa-icon>
</div>
@if (option$) {
  <cft-filter-dropdown
    (selected)="selected($event)"
    (keepFocus)="focus()"
    [noOptionsMessage]="(noOptionsMessage$() | async) || ''"
    [option$]="option$"
    data-testid="filterDropdown"
  ></cft-filter-dropdown>
}
